//Des variables
const state = () => ({
  message : "pouet",
  status  : 200,
  date    : new Date,
})

//Comment ces variables changent
const mutations = {
}

//Combo de plusieurs mutations
const actions = {
}

//Etat d'un state retravaillé (mise en forme, concaténation, etc.)
const getters = {
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}